import {
    Mesh,
    DoubleSide,
    MeshBasicMaterial
} from 'three';

import { VRObject3D } from './VRObject3D';
import { squareGeometry, emptyTexture, INDICATOR_HIT_SIZE } from './helpers/texturesAndGeometries';
import { initQuillEditor, setQuillContent, getQuillContent, getQuillEditor } from './helpers/editorHelpers';
import { AMPLITUDE_EVENTS, trackAnalytics } from '../Tracking/baglessAnalytics';


class VRInfoElement extends VRObject3D {

    constructor(containerName, camera, texture, x, y, z, model) {

        super(containerName);

        this.camera = camera;
        this.material = new MeshBasicMaterial({ map: texture, side: DoubleSide, transparent: true });

        this.mesh = new Mesh(squareGeometry, this.material);
        this.mesh.type = 'infoElement';
        this.mesh.name = 'infoElement';
        this.name = 'infoElement';
        this.type = 'infoElement';

        this.model = model;
        // Info elements always use the 2D indicator (no custom mesh image).
        this.customIcon = false;

        // INIT
        this.camera !== null ? this._setInitialPosRot() : this.setPosition(x, y, z);

        this.add(this.mesh);

        this.mesh.groupDetails = { title: $trans('info-element'), icon: 'info', editTitle: $trans('edit-info-element'), dataLang: 'edit-info-element' }

        this.editControls();

        //result
        return this;
    }

    setDbConfig(config) {
        super.setDbConfig(config);
        this.customIcon = false;
        if (this.model?.editMode && this.mesh?.material) {
            this.mesh.material.map = emptyTexture;
            this.mesh.material.needsUpdate = true;
            this.updateMeshGeometry(INDICATOR_HIT_SIZE, INDICATOR_HIT_SIZE);
        }
    }

    showEditModal = () => {
        $(".info-element-modal .modal-header-title").text($trans('edit-info-element'));
        $(".info-element-modal .modal-header-title").attr('data-lang', 'edit-info-element');
        $(".info-element-modal").addClass("edit");

        const { data } = this.dbConfig;
        const { title, description, button, image } = data;

        const isLocation = button.hasOwnProperty('isLocation') ? button.isLocation : false;

        $("#info-element-title").val(title);

        // Initialize Quill editor if not already initialized
        if (!this.quillEditor) {
            const selector = "#info-element-description1";
            this.quillEditor = getQuillEditor(selector) || initQuillEditor(selector, {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline'], ['link'],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['clean']
                    ]
                },
                placeholder: 'Enter description...'
            });
        }

        // Set content
        setQuillContent("#info-element-description1", description);

        const showAdvertisementLinks = this.dbConfig?.advertisementLinks === '1';
        $("#info-element-description-advertisement-links").prop("checked", showAdvertisementLinks);

        $("#info-element-button-text").val(button.text);
        $("#info-element-button-url").val(button.url);

        $("#locationButton").val(isLocation ? button.locationID : $("#locationButton option:first").val());
        $(".locationButton .select-selected").text(isLocation ? button.locationName : '');

        $("#info_element_image").attr("src", data.hasOwnProperty('image') ? data.image || './textures/empty.png' : './textures/empty.png');
        $("#info_element_video").attr("src", data.hasOwnProperty('video') ? data.video || '#' : '#');

        const imageCond = !$("#info_element_image").attr("src").includes('/empty.png');
        const videoCond = $("#info_element_video").attr("src") !== '#';

        $("#upload_info_element_image .upload-watermark").toggleClass("hide", imageCond);
        $("#upload_info_element_video .upload-watermark").toggleClass("hide", videoCond);
        $("#info_element_video").parent().toggleClass("active", videoCond);
        $("#info_element_video").toggleClass("active", videoCond);

        $("#removeInfoElementImage").toggleClass("active", imageCond);
        $("#removeInfoElementVideo").toggleClass("active", videoCond);

        $("#info-element-modal").addClass("is-active");
    }

    openModal = () => {
        const { data } = this.dbConfig;
        const { title, description, button, image } = data;
        $(".info-element-modal").removeClass("edit");
        $("#infoElementTitle").text(title);
        const imgDom = image ? `<div class='infoModalImage'><img src='${image}''></div>` : '';
        const descDom = description ? `<div class='infoModalDescription'>${description}</div>` : '';
        let videoDom = '';
        if (data.hasOwnProperty('video')) {
            videoDom = data.video ? `<div id="info_element_video_holder" class="active"><video id="infoElementVideo" autoplay muted><source src='${data.video}'></source></video><div id="unmute_info_element_video"><span class='material-icons md-18'>volume_off</span></div></div>` : '';
        }
        const showAdvertisementLinks = this.dbConfig?.advertisementLinks === '1';
        if (!showAdvertisementLinks) {
            $(".info-element-description-advertisement-links").parent().remove();
        }

        let wrap = '';
        wrap += imgDom;
        wrap += videoDom;
        wrap += descDom;

        const isLocation = button.hasOwnProperty('isLocation') ? button.isLocation : false;
        $("#infoElementBtnUrl").toggleClass("isLocation", isLocation);

        $("#infoElementBtnUrl").attr("href", isLocation ? button.locationID : button.url);
        $("#infoElementBtnText").text(button.text);

        $("#infoElementModal footer").toggleClass("visible", button.show);
        $("#info-element-content").html(wrap);

        const anyDescription = descDom !== "";

        $("#info-element-content").toggleClass('pad-top', anyDescription && !imgDom);
        $("#info-element-content").toggleClass('pad-bot', anyDescription);
        $("#info-element-content").toggleClass('pad-bot-big', anyDescription && !button.show);
        $("#infoElementModal footer").toggleClass('no-mar', button.show && !anyDescription);

        $("#infoElementModal").addClass("is-active");
        trackAnalytics(this.model, AMPLITUDE_EVENTS.SAW_INFO_PANEL, {
            object_id: this.dbConfig?.id,
            object_type: 'infoElement',
            object_label: 'Info element',
            object_name: this.dbConfig?.data?.title,
        });
    }

    closeModal = () => {
        const $modal = $("#infoElementModal");
        if (!$modal.hasClass("is-active")) return;
        $modal.removeClass("is-active");
        const videoDom = $("#infoElementVideo");
        if (videoDom.length > 0) {
            const video = videoDom.get(0);
            video.pause();
            video.currentTime = 0;
        }
    }
}

export { VRInfoElement };
